import { useEffect } from "react";
import { JournalViewModel } from "../../../ViewModel/JournalViewModel";
import { IHeaderSetters } from "../Journal";
import ScoreTrendChart from "../SharedComponents/GLChart";







export function TrendsPage({ headerSetters, journalViewModel }: { journalViewModel: JournalViewModel, headerSetters: IHeaderSetters }) {


    useEffect(() => {
        headerSetters.setHeaderTitle(`Trends`);
        headerSetters.setHeaderDate('');
    }, []);


    return (
        <div className="pl-100 pr-100">
            <ScoreTrendChart viewmodel={journalViewModel.ScoreTrendViewModel} />
        </div>
    );
}